import { render, staticRenderFns } from "./FeedShareDialog.vue?vue&type=template&id=36e101e3&scoped=true"
import script from "./FeedShareDialog.vue?vue&type=script&lang=js"
export * from "./FeedShareDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedShareDialog.vue?vue&type=style&index=0&id=36e101e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e101e3",
  null
  
)

export default component.exports